PIXI.settings.SPRITE_MAX_TEXTURES = Math.min(PIXI.settings.SPRITE_MAX_TEXTURES , 16);

var myPixiObj={};
var myPixiElement={};


myPixiElement.custom={
    init:function(conf){
        this.opacity_step=0;
        this.opacity_step_max=0;
        this.opacity_dir=1;
        this.opacity_conf={};
        this.delta_sum=0;
        this.conf=conf;
    },
    playSound:function(name){
        this.sound_name=_mySound.playSound(name);
    },
    stopSound:function(){
        _mySound.stopSound(this.sound_name);
    },
    myUpdate:function(delta){
        this.delta_sum+=delta;
         if(this.opacity_step_max>0){
            this.opacity_step+=delta;
            var div_opacity=0;
            if(this.opacity_step>this.opacity_step_max){
                this.opacity_step=this.opacity_step_max;
                this.opacity_step_max=0;
                if(this.opacity_conf.opacity_dir>0){
                    div_opacity=1;
                }
                else{
                    div_opacity=0;
                }
                this.opacity_conf.onEnd.call(this);
            }
            else{
                if(this.opacity_conf.opacity_dir>0){
                    div_opacity=this.opacity_step/this.opacity_step_max;
                }
                else{
                    div_opacity=1-this.opacity_step/this.opacity_step_max;
                }
            }
            div_opacity=Math.max(0,div_opacity);
            div_opacity=Math.min(1,div_opacity);
            this.alpha=div_opacity;
        }
    },
    privateFade:function(opacity_step_max,conf){
        var opacity_step_max_old=this.opacity_step_max;
        this.opacity_step_max=0;
        var opacity_conf_old=copyObj(this.opacity_conf);
        conf=$.extend(true,{
            step:-1,
            opacity_dir:1,
            onEnd:function(){}
        },conf);
        this.opacity_conf=conf;
        if(conf.step==-1){
            if(this.opacity_step==opacity_step_max_old || opacity_step_max_old==0 || typeof opacity_conf_old.opacity_dir=="undefined"){
                conf.step=0;
            }
            else{
                if(opacity_conf_old.opacity_dir==conf.opacity_dir){
                    conf.step=this.opacity_step/opacity_step_max_old*opacity_step_max;
                }
                else{
                    conf.step=(1-this.opacity_step/opacity_step_max_old)*opacity_step_max;
                }
            }
        }
        this.opacity_step=conf.step;
        this.opacity_step_max=opacity_step_max;
        return conf;
    },
    fadeOut:function(opacity_step_max,conf){
        if(typeof conf=="undefined"){
            conf={};
        }
        conf.opacity_dir=-1;
        conf=this.privateFade(opacity_step_max,conf);
    },
    fadeIn:function(opacity_step_max,conf){
        if(typeof conf=="undefined"){
            conf={};
        }
        conf.opacity_dir=1;
        this.opacity_conf=this.privateFade(opacity_step_max,conf);
    },
    fadeStop:function(){
        this.opacity_step_max=0;
    }
};

;


myPixiElement.img=function(conf){
    conf=$.extend(true,{
        anchor:[0.5,0.5],
        pos:[0,0],
        scaleTo:[0,0]
    },conf);
    this.conf=conf;
    this.texture = PIXI.utils.TextureCache[conf.img];
    PIXI.Sprite.call(this,this.texture);
    this.x=conf.pos[0];
    this.y=conf.pos[1];
    
    myPixiElement.custom.init.call(this,conf);
    this.anchor.set(conf.anchor[0],conf.anchor[1]);
    
    this.conf.width=this.texture.baseTexture.width;
    this.conf.height=this.texture.baseTexture.height;
    if(conf.scaleTo[0] > 0 || conf.scaleTo[1] > 0) {
      var scale=Math.min(conf.scaleTo[0]/this.conf.width,conf.scaleTo[1]/this.conf.height)
      this.setTransform(this.x,this.y,scale,scale);
    }
};
myPixiElement.img.prototype = Object.create(PIXI.Sprite.prototype);
myPixiElement.img.prototype= $.extend(myPixiElement.img.prototype,myPixiElement.custom,{
    myUpdate:function(delta){
         myPixiElement.custom.myUpdate.call(this,delta);
    },
    myRemove:function(){
        
    }
});


myPixiElement.arrow=function(conf){
    conf=$.extend(true,{
        img:"",
        angle:0,//90,180,270,0
        range:15,//px -/+ max
        speed:60,//px on step
        is_vertical:1,
        pos:[0,0],
        scale:100,
    },conf);
    myPixiElement.img.call(this,conf);
    if(this.conf.scale!=100){
        this.scale.set(this.conf.scale/100,this.conf.scale/100);
    }
    this.rotation=this.conf.angle/180*Math.PI;
}
myPixiElement.arrow.prototype = Object.create(myPixiElement.img.prototype);
myPixiElement.arrow.prototype= $.extend(myPixiElement.img.prototype,{
    updateSet:function(opt){
        this.conf=$.extend(true,this.conf,opt);
        this.x=this.conf.pos[0];
        this.y=this.conf.pos[1];
        this.scale.set(this.conf.scale/100,this.conf.scale/100);
        this.rotation=this.conf.angle/180*Math.PI;
    },
    myUpdate:function(delta){
        myPixiElement.custom.myUpdate.call(this,delta);
        if(this.conf.range>0){
            var range=(this.delta_sum/100*this.conf.speed)%(this.conf.range*4)-this.conf.range;
            if(range>this.conf.range){
                range=this.conf.range*2-range;
            }
            if(this.conf.is_vertical){
                this.y=this.conf.pos[1]+range;
            }
            else{
                this.x=this.conf.pos[0]+range;
            }
        }
    },
});





///home/cpiusz/public_html/fakelay/code/gfx/ui/arrows/blue.png


myPixiElement.container=function(conf){
    conf=$.extend(true,{},conf);
    PIXI.Container.call(this);
    myPixiElement.custom.init.call(this,conf);
};
myPixiElement.container.prototype = Object.create(PIXI.Container.prototype);
myPixiElement.container.prototype=$.extend(myPixiElement.container.prototype,myPixiElement.custom,{
    myUpdate:function(delta){
         myPixiElement.custom.myUpdate.call(this,delta);
    },
    myRemove:function(){
        this.destroy();
    },
    takeContainerPos:function(){
        return [this.x,this.y];
    }
});

myPixiElement.imgCrop=function(conf){
    conf=$.extend(true,{
        anchor:[0.5,0.5],
        pos:[0,0],
        size:[100,100],//new image size
        cropPos:[0,0],//position off cropping
    },
    conf);
    this.conf=conf;
    
    
    
    
    
    this.texture = new PIXI.Texture(PIXI.utils.TextureCache[conf.img]);
    this.texture.frame=new PIXI.Rectangle(this.conf.cropPos[0],this.conf.cropPos[1],this.conf.size[0],this.conf.size[1]);
    PIXI.Sprite.call(this,this.texture);
    this.x=conf.pos[0];
    this.y=conf.pos[1];
    
    myPixiElement.custom.init.call(this,conf);
    this.anchor.set(conf.anchor[0],conf.anchor[1]);
};
myPixiElement.imgCrop.prototype = Object.create(PIXI.Sprite.prototype);
myPixiElement.imgCrop.prototype= $.extend(myPixiElement.imgCrop.prototype,myPixiElement.custom,{
    myUpdate:function(delta){
         myPixiElement.custom.myUpdate.call(this,delta);
    },
    myRemove:function(){
        
    }
});


myPixiElement.spine=function(conf){
    conf=$.extend(true,{
        pos:[0,0]
    },conf);
    conf.spine_conf=$.extend(true,{
        anim_loop:false,
        updateAnim:false,//update anim by myUpdate
        anim_name:"animation",
        auto_start:true,
        spineResource:{},
        scale:100,
        freeze_part:-1,//[0,1]
        eye_conf:{
            slot_name:"",
            prefix:"eye",
            step_max:2,
            interval:100,
            scene_range:[10,40],
        },
        eye_arr:[],//array of eye_conf
        onAnimComplete:function(){}
    },conf.spine_conf);
    var i;
    for(i in conf.spine_conf.eye_arr){
        conf.spine_conf.eye_arr[i]=$.extend(true,{},conf.spine_conf.eye_conf,conf.spine_conf.eye_arr[i]);
    }
    this.conf=conf;
    
    
    PIXI.spine.Spine.call(this,conf.spine_conf.spineResource[conf.img].spineData);
    
    this.storage={
        eyeState:{step_start:mt_rand(1,conf.spine_conf.eye_conf.scene_range[1]),img_last:0},
        eyeArr:{},
        force_autoupdate:false
    };
    
    myPixiElement.custom.init.call(this,conf);
    
    if(conf.spine_conf.freeze_part>-1){
        this.autoUpdate = false;
    }
    if(conf.spine_conf.scale!=100){
        this.scale.set(conf.spine_conf.scale/100);
    }
    if(conf.pos[0]!==0 || conf.pos[1]!==0){
        this.x=conf.pos[0];
        this.y=conf.pos[1];
    }
    if(!this.conf.spine_conf.auto_start || conf.spine_conf.updateAnim){
        this.autoUpdate = false;
    }
    this.state.setAnimation(0, conf.spine_conf.anim_name, conf.spine_conf.anim_loop);
    
    if(!this.conf.spine_conf.auto_start){
        this.update(0);
        if(conf.spine_conf.updateAnim==false){
            this.storage.force_autoupdate=true;
        }
    }
    
    
    if(conf.spine_conf.freeze_part>-1){
        this.update(conf.spine_conf.freeze_part*this.state.tracks[0].animationEnd);
    }
    var thc=this;
    this.state.addListener({
        complete: function(){
            if(thc.funArr.length>0){
                var fun=thc.funArr.shift();
                fun.call(thc);
            }
            else{
                 conf.spine_conf.onAnimComplete.call(thc);
            }
        }
    });
    this.funArr=[];
    
//    this.myEye();
//    this.hideAttachment("glowa");
};
myPixiElement.spine.prototype = Object.create(PIXI.spine.Spine.prototype);
myPixiElement.spine.prototype= $.extend(myPixiElement.spine.prototype,myPixiElement.custom,{
    myUpdate:function(delta){
        myPixiElement.custom.myUpdate.call(this,delta);
        
        if(this.conf.spine_conf.freeze_part!=-1 && this.conf.spine_conf.updateAnim){
            this.update(delta/60);
        }
        this.myEye();
    },
    changeEye:function(conf_obj){
        var conf=$.extend(true,{
            slot_name:this.conf.spine_conf.eye_conf.slot_name,
            prefix:this.conf.spine_conf.eye_conf.prefix,
            scene_range:copyArray(this.conf.spine_conf.eye_conf.scene_range),
            interval:this.conf.spine_conf.eye_conf.interval,
            step_max:this.conf.spine_conf.eye_conf.step_max,
        },conf_obj);
        
        
        this.conf.spine_conf.eye_conf=$.extend(true,this.conf.spine_conf.eye_conf,conf);
        if(conf.slot_name){
            this.storage.eyeArr=[];
            this.skeleton.setAttachment(conf.slot_name,this.conf.spine_conf.eye_conf.prefix+"0");
        }
        
    },
    onCompleteOnce:function(fun){
        this.funArr.push(fun);
    },
    clearCompleteOnce:function(){
        this.funArr=[];
    },
    myEye:function(){
        //eye0,eye1,eye2
        if(this.conf.spine_conf.eye_arr.length>0){
            var i;
            for(i in this.conf.spine_conf.eye_arr){
                this.myEyePriv(this.conf.spine_conf.eye_arr[i],i);
            }
        }
        else if(this.conf.spine_conf.eye_conf.slot_name!=""){
            this.myEyePriv(this.conf.spine_conf.eye_conf,0);
        }
        return false;
    },
    myEyePriv:function(qconf,index){
        if(typeof this.storage.eyeArr[index]=="undefined"){
            this.storage.eyeArr[index]={step_start:mt_rand(1,qconf.scene_range[1]),img_last:0}
        }
        
        
        var time_one=qconf.interval/(1000/60);
        var step_org=Math.round(this.delta_sum/time_one);
        var step=step_org-this.storage.eyeArr[index].step_start;
        var img;
        if(step<0){
            img=0;
        }
        else if(step>qconf.step_max*2-1){
            img=0;
            this.storage.eyeArr[index].step_start=step_org+mt_rand(qconf.scene_range[0],qconf.scene_range[1]);
        }
        else{
            img=qconf.step_max-Math.abs(step-qconf.step_max);
        }
        if(this.storage.eyeArr[index].img_last!=img){
            this.storage.eyeArr[index].img_last=img;
            this.skeleton.setAttachment(qconf.slot_name,qconf.prefix+img);
        }
    },
    showAttachment:function(slot_name,attachment_name){
//        $.qLog("s_"+slot_name+"_"+attachment_name+" ");
        this.skeleton.setAttachment(slot_name,attachment_name);
    },
    hideAttachment:function(slot_name){
        if(this.skeleton.findSlot(slot_name)!==null){
            
//            $.qLog("h_"+slot_name+" ");
            this.skeleton.setAttachment(slot_name,null);
        }
    },
    haveAnim:function(name){
        var i;
        for(i in this.spineData.animations){
            if(this.spineData.animations[i].name==name){
                return true;
            }
        }
        return false;
    },
    playAnim:function(name){
        if(this.storage.force_autoupdate){
            this.autoUpdate = true;
        }
        this.conf.spine_conf.anim_name=name;
//        try{
            this.state.setAnimation(0, this.conf.spine_conf.anim_name, this.conf.spine_conf.anim_loop);
//            console.log(this.state);
//        }
//        catch(e){
//            console.log(name+"_");
//            console.log(this);
//        }
        
    },
    takeCurAnimName:function(){
        return this.conf.spine_conf.anim_name;
    },
    myRemove:function(){
        this.destroy();
    }
});



myPixiElement.sprite=function(conf){
    conf.sprite_conf=$.extend({
        clips:0,
        columns:0,
        clip_size:[0,0],//will be set
        frame_duration:50,//ms
        frame_start:0,
        loop:true,
    },conf.sprite_conf);
    if(!conf.sprite_conf.columns){
        conf.sprite_conf.columns=conf.sprite_conf.clips;
    }
    conf.sprite_conf.rows=Math.ceil(conf.sprite_conf.clips/conf.sprite_conf.columns);
    this.conf=conf;
    
    var texture = new PIXI.Texture(PIXI.utils.TextureCache[conf.img]);
    PIXI.Sprite.call(this,texture);
    myPixiElement.custom.init.call(this,conf);
    
    conf.sprite_conf.clip_size=[this.width/conf.sprite_conf.columns,this.height/conf.sprite_conf.rows];
    

    this.frame_id=intval(conf.sprite_conf.frame_start);
    
    var frame_id=this.frame_id;
    var x=frame_id%conf.sprite_conf.columns*conf.sprite_conf.clip_size[0];
    var y=0;
    if(conf.sprite_conf.rows>1){
        y=Math.floor(frame_id/conf.sprite_conf.columns)*conf.sprite_conf.clip_size[1];
    }
    
    
    this.texture.frame=new PIXI.Rectangle(x,y,conf.sprite_conf.clip_size[0],conf.sprite_conf.clip_size[1]);
    this.anchor.set(0.5);
};
myPixiElement.sprite.prototype = Object.create(PIXI.Sprite.prototype);
myPixiElement.sprite.prototype= $.extend(myPixiElement.sprite.prototype,myPixiElement.custom,{
    myUpdate:function(delta){
        myPixiElement.custom.myUpdate.call(this,delta);
        
        var conf=this.conf.sprite_conf;
        var frame_id=Math.round(this.delta_sum*1000/60/conf.frame_duration);
        if(frame_id>=conf.clips && !conf.loop){
            frame_id=conf.clips-1;
        }
        else{
            frame_id=frame_id%conf.clips;
        }
        this.setFrame(frame_id);
        
    },
    setFrame:function(frame_id){
        if(frame_id!=this.frame_id){
            var conf=this.conf.sprite_conf;
            this.frame_id=frame_id;
            var x=frame_id%conf.columns*conf.clip_size[0];
            var y=0;
            if(conf.rows>1){
                y=Math.floor(frame_id/conf.columns)*conf.clip_size[1];
            }
            
            this.texture.frame=new PIXI.Rectangle(x,y,conf.clip_size[0],conf.clip_size[1]);
        }
    },
    myRemove:function(){
        this.destroy();
    }
});




myPixiElement.imgFrame=function(conf){
    if(typeof conf.imgFrame_conf=="undefined"){
        conf.imgFrame_conf={};
    }
    conf.imgFrame_conf=$.extend({
        v_arr:[0,0],
        s_arr:[0,0],
        anchor_arr:[0.5,0.5]
    },conf.imgFrame_conf);
    var conf_cur=conf.imgFrame_conf;
    this.conf=conf;
    this.isRunning=1;
    
    var texture = new PIXI.Texture(PIXI.utils.TextureCache[conf.img]);
    PIXI.Sprite.call(this,texture);
    myPixiElement.custom.init.call(this,conf);
    
    this.clip_size=[this.width,this.height];
    if(conf_cur.s_arr[0]=="max"){
        conf_cur.s_arr[0]=this.width;
    }
    if(conf_cur.s_arr[1]=="max"){
        conf_cur.s_arr[1]=this.height;
    }
    
    this.myBox=[conf_cur.s_arr[0],conf_cur.s_arr[0]];
    
    this.texture.frame=new PIXI.Rectangle(0,0,this.myBox[0],this.myBox[1]);
    this.anchor.set(conf_cur.anchor_arr[0],conf_cur.anchor_arr[1]);
    
};
myPixiElement.imgFrame.prototype = Object.create(PIXI.Sprite.prototype);
myPixiElement.imgFrame.prototype= $.extend(myPixiElement.imgFrame.prototype,myPixiElement.custom,{
    myUpdate:function(delta){
        myPixiElement.custom.myUpdate.call(this,delta);
       
        
        if(!this.isRunning){
            return false;
        }
        var conf_cur=this.conf.imgFrame_conf;
        
        
        var box_x=conf_cur.s_arr[0]+conf_cur.v_arr[0]*this.delta_sum;
        box_x=Math.min(Math.max(0,box_x),this.clip_size[0]);
        
        var box_y=conf_cur.s_arr[1]+conf_cur.v_arr[1]*this.delta_sum;
        box_y=Math.min(Math.max(0,box_y),this.clip_size[1]);
        
        if(this.myBox[0]!=box_x || this.myBox[1]!=box_y){
            this.myBox=[box_x,box_y];
            this.texture.frame=new PIXI.Rectangle(0,0,this.myBox[0],this.myBox[1]);
        }
        
    },
    
    stop:function(){
        this.isRunning=0;
    },
    myRemove:function(){
        this.destroy();
    }
});










//myPixiElement.sprite=function(conf){
//    conf.sprite_conf=$.extend({
//        spineResource:{}
//    },conf.sprite_conf);
//    this.conf=conf;
//    console.log(conf.sprite_conf.spineResource);
//    var sh=conf.sprite_conf.spineResource[conf.img].spritesheet;
//    console.log(sh);
//    PIXI.extras.AnimatedSprite.call(this,);
//    this.anchor.set(0.5);
//};
//myPixiElement.sprite.prototype = Object.create(PIXI.extras.AnimatedSprite.prototype);
//myPixiElement.sprite.prototype= $.extend(PIXI.extras.AnimatedSprite.prototype,{
//    myUpdate:function(delta){
//        
//    },
//    myRemove:function(){
//        
//    }
//});



myPixiObj.drawLines=function(conf){
    PIXI.Container.call(this);
    
    conf=$.extend({
        pos:[0,0],
        img:"",
        scale:100,
        step_max:200,
        distance:1000,
        opacity_arr:[],
        anim_type:"img",
        spine_conf:{},
        img_conf:{},
        sprite_conf:{}
    },conf);
    var len=conf.distance;
    this.opacityLen=conf.opacity_arr.length;
    if(this.opacityLen){
        this.opacityFun=new Smooth(conf.opacity_arr);
    }
//    this.scale=conf.scale;
    this.step=1;
    this.step_max=conf.step_max;
    this.imgName=conf.img;
    this.imgArr=[];
    

    var i;
    for (i = 0; i < 6; i++) {
        this.imgArr[i] = new myPixiElement[conf.anim_type](conf);
        this.imgArr[i].scale.set(conf.scale/100);
        this.addChild(this.imgArr[i]);
    }

    this.arr_dir=[
        scaleVector([0,-1],len),
        scaleVector([0,1],len),
        scaleVector([1,Math.cos(360/5*Math.PI/180)],len),
        scaleVector([1,Math.cos(2*360/5*Math.PI/180)],len),
        scaleVector([-1,Math.cos(2*360/5*Math.PI/180)],len),
        scaleVector([-1,Math.cos(360/5*Math.PI/180)],len),
    ];
//    this.rotation=mt_rand(0,360)/180*Math.PI;
    this.x=conf.pos[0];
    this.y=conf.pos[1];
    
};
myPixiObj.drawLines.prototype = Object.create(PIXI.Container.prototype);
myPixiObj.drawLines.prototype= $.extend(myPixiObj.drawLines.prototype,{
    update:function(delta){
        var div=this.step/this.step_max;
        this.step+=(delta+Math.pow(div-1,2))*1.3*0.4;
        var opacity=100;
        if(this.opacityLen){
            opacity=Math.max(0,this.opacityFun(this.step/this.step_max*(this.opacityLen-1)));
        }

        var x,y;
        var i,dir;
        for(i in this.arr_dir){
            dir=this.arr_dir[i];
            x=dir[0]*div;
            y=dir[1]*div;
            this.imgArr[i].x=x;
            this.imgArr[i].y=y;
            this.imgArr[i].myUpdate(delta);
//            if(i==0){
//                $.qLog(x+"_"+y+" ");
//            }
            
        }
        if(opacity!=100){
            this.alpha=opacity/100;
        }

        if(this.step>=this.step_max){
            return 0;
        }
        return 1;
    },
    remove:function(){
        var i;
        for(i in this.imgArr){
            this.imgArr[i].myRemove();
        }
        this.destroy();
    }
});


myPixiObj.showText=function(txt,conf){
    PIXI.Container.call(this);
    
    this.txt=txt;
    this.step=0;
    conf=$.extend({
        pos:[0,0],
        font_color:"#000000",
        font_size:25,
        border_color:"",
        border_size:0,
        step_max:0,
        step_max_fadeout:0,
        font_family: "Montserrat",
        onUpdate:undefined,
        anchor:[0.5,0.5]
        
    },conf);
    this.conf=conf;
    var styleObj={
        fontFamily: conf.font_family,
        fontSize: conf.font_size,
        fill: conf.font_color,
    };
    if(conf.border_size){
        styleObj.stroke=conf.border_color;
        styleObj.strokeThickness=conf.border_size;
    }
    var style = new PIXI.TextStyle(styleObj);



    this.textObj= new PIXI.Text(txt,style);
    this.textObj.anchor.set(conf.anchor[0],conf.anchor[1]);
//    this.textObj.x=this.margin[0];
//    this.textObj.y=this.margin[1];  

    this.addChild(this.textObj);
    this.step_max_fadeout=conf.step_max_fadeout;
    this.step_max=conf.step_max;
    this.x=conf.pos[0];
    this.y=conf.pos[1];


};
myPixiObj.showText.prototype = Object.create(PIXI.Container.prototype);
myPixiObj.showText.prototype= $.extend(myPixiObj.showText.prototype,{
    update:function(delta){
        if(typeof this.conf.onUpdate!="undefined"){
            this.conf.onUpdate.call(this,delta);
        }
        
        if(this.step_max>0){
            this.step+=delta;
        }


        if(this.step_max_fadeout>0 && this.step>this.step_max){
            this.alpha   = 1-Math.min(1,(this.step-this.step_max)/this.step_max_fadeout);
        }
        if(this.step_max>0 && this.step_max+this.step_max_fadeout<=this.step){
            return 0;
        }

        return 1;

    },
    changeText:function(txt){
        this.textObj.text=txt;
    },
    remove:function(){
        this.destroy();
    }
});



myPixiObj.drawCustom=function(conf){
    myPixiElement.container.call(this,{});
    conf=$.extend({
        pos_start:[0,0],
        pos_end:[100,100],
        img:"heart",
        step_max:400,
        scale_arr:[100,100],
        opacity_arr:[],
        rotation_arr:[0,0],
        chibiMove:{step_max:0,y_max:0,angle_max:0},//{step_max:10,y_max:10,angle_max:10}
        anim_type:"img",
        sm_points_arr:[],
        anchor:[0.5,0.5],
        a:0,
        v:0,
        dir:1,
        spine_conf:{},
        img_conf:{},
        sprite_conf:{},
        onEndAnim:false,
        onStepArr:[],//{step:40,fun:function()}
        
    },conf);
    this.conf=conf;
    this.step=1;
    
    this.start_point=copyArray(conf.pos_start);
    this.end_point=copyArray(conf.pos_end);
    this.scale_arr=copyArray(conf.scale_arr);
    this.scale_int=conf.scale_arr[0];
    
    this.opacityLen=conf.opacity_arr.length;
    if(this.opacityLen){
        this.opacityFun=new Smooth(conf.opacity_arr);
        this.alpha=conf.opacity_arr[0]/100;
    }
    
    
    
    this.rotation_arr=copyArray(conf.rotation_arr);
    if(this.rotation_arr[0]!=0){
        var angle=this.rotation_arr[0];
        this.rotation=angle/180*Math.PI;
    }

    this.dir=makeVector(this.start_point,this.end_point);
    this.imgName=conf.img;
    
    if(conf.anim_type=="object"){
      this.myObj = conf.object;
    } else {
      this.myObj = new myPixiElement[conf.anim_type](conf);
    }
    
    if(this.scale_int!=100 || this.conf.dir!=1){
        this.scale.set(this.conf.dir*this.scale_int/100,this.scale_int/100);
    }
    var thc=this;
    thc.countStepMax();
   
    
    this.sm_points_len=conf.sm_points_arr.length;
    if(this.sm_points_len>0){
        this.sm_points_obj=new Smooth(conf.sm_points_arr);
        var i,p1,p2,dist=0;
        for(i=0;i<this.sm_points_len-2;i++){
            p1=conf.sm_points_arr[i];
            p2=conf.sm_points_arr[i+1];
            dist+=lengthVector(minusVector(p1,p2));
        }
        this.step_max=dist/conf.v;
        this.x=conf.sm_points_arr[0][0];
        this.y=conf.sm_points_arr[0][1];
    }
    else{
        this.x=this.start_point[0];
        this.y=this.start_point[1];
    }
    this.storage={
        dontKillOnStop:1,
        active:1,
        step_max_old:0,
    };
    if(this.conf.chibiMove.step_max>0){
        this.storage.chibiMove={dir:0,step:0};
    }
    
    this.addChild(this.myObj);
};
myPixiObj.drawCustom.prototype = Object.create(myPixiElement.container.prototype);
myPixiObj.drawCustom.prototype= $.extend(myPixiObj.drawCustom.prototype,{
    countStepMax:function(){
        this.step_all=0;
        this.step_max=this.conf.step_max;
        if(this.conf.v>0 || this.conf.a!=0){

            var s=lengthVector(this.dir);
            if(this.conf.a!=0){
                this.step_max=(-this.conf.v+Math.sqrt(this.conf.v*this.conf.v+2*s*this.conf.a))/this.conf.a;
            }
            else{
                this.step_max=s/this.conf.v;
            }
        }
    },
    update:function(delta){
        myPixiElement.custom.myUpdate.call(this,delta);
        this.myObj.myUpdate(delta);
        this.step_all+=delta;
        if(this.step_max==0){
            return this.storage.dontKillOnStop;
        }
        var step_old=this.step;
        var div=this.step/this.step_max;
        this.step+=delta;
        var x,y;
        if(this.sm_points_len==0){
            x=this.dir[0]*div+this.start_point[0];
            y=this.dir[1]*div+this.start_point[1];
        }
        else{
            var pp=this.sm_points_obj(div*(this.sm_points_len-1));
            x=Math.round(pp[0]);
            y=Math.round(pp[1]);
            
        }
        
        var angle_change=false,angle=0;
        var scale_change=false,scale=1;
        
        if(this.scale_arr[0]!=this.scale_arr[1]){
            scale_change=true;
            this.scale_int=this.scale_arr[0]+(this.scale_arr[1]-this.scale_arr[0])*div;
        }
        
        
        if(this.conf.chibiMove.step_max>0){
            this.storage.chibiMove.step+=delta;
            if(this.storage.chibiMove.step>this.conf.chibiMove.step_max){
                this.storage.chibiMove.dir=(this.storage.chibiMove.dir+1)%2;
                this.storage.chibiMove.step=this.storage.chibiMove.step%this.conf.chibiMove.step_max;
            }
            angle_change=true;
            var div_cb=this.storage.chibiMove.step/this.conf.chibiMove.step_max;
            if(this.storage.chibiMove.dir==1){
                div_cb=1-div_cb;
            }
            y+=div_cb*this.conf.chibiMove.y_max*this.scale_int/100;
            angle+=div_cb*this.conf.chibiMove.angle_max;
        }
        
        
        this.x=x;
        this.y=y;
//        
//        

        if(scale_change){
            this.scale.set(this.conf.dir*this.scale_int/100,this.scale_int/100);
        }
        if(this.opacityLen){
            var opacity=Math.max(0,this.opacityFun(div*(this.opacityLen-1)));
            this.alpha=opacity/100;
        }
//        
        
//        
        if(this.rotation_arr[0]!=this.rotation_arr[1]){
            angle_change=true;
            angle+=this.rotation_arr[0]+(this.rotation_arr[1]-this.rotation_arr[0])*div;
        }
        if(angle_change){
            this.rotation=angle/180*Math.PI;
        }
//
        
//        onStepArr:[],//{step:40,fun:function()}
        
        var i,bum;
        for(i in this.conf.onStepArr){
            bum=this.conf.onStepArr[i];
            if(bum.step>step_old && bum.step<=this.step){
                bum.fun.call(this);
            }
        }
        
        
        if(this.step>=this.step_max){
            this.storage.active=0;
            if(typeof this.conf.onEndAnim=="function"){
                this.conf.onEndAnim.call(this);
            }
        }



        return this.storage.active;
    },
    pause:function(){
        if(this.step_max!=0){
            this.storage.step_max_old=this.step_max;
        }
        this.step_max=0;
    },
    resume:function(){
        this.step_max= this.storage.step_max_old;
    },
    endNow:function(){
        this.storage.dontKillOnStop=0;
        this.step_max=0;
    },
    updateConfig:function (conf) {
        this.step=0;
        this.start_point=copyArray(conf.pos_start);
        this.end_point=copyArray(conf.pos_end);
        this.dir=makeVector(this.start_point,this.end_point);
        this.countStepMax();
        if(typeof conf.step_max!="undefined"){
            this.step_max=conf.step_max;
        }
        this.storage.active=1;
        this.x=this.start_point[0];
        this.y=this.start_point[1];
        this.conf.onEndAnim = conf.onEndAnim;
    },
    remove:function(){
        this.myObj.myRemove();
        this.destroy();
    }
});

myPixiObj.myGirl=function(conf){
    conf=$.extend(true,{
        girl_id:1,
        prefix:"girlOwn",
        is_own:1,
        pos:[0,0],
        suitObj:{},
        eye:{
            interval:100,
            scene_range:[10,40]
        },
        anchor:[0.5,1]
    },conf);
    myPixiElement.container.call(this,{});
    this.conf=conf;
    this.storage={
        eye:{
            img_last:-1,
            dir:1,
            deltaMultiply:1000/60/this.conf.eye.interval,
            step_last:-1000,
            step_max:mt_rand(conf.eye.scene_range[0],conf.eye.scene_range[1])
        }
    };
    this.eyeArr=[];
    this.storage.eye.step=mt_rand(0,this.storage.eye.step_max-1);
    this.to_remove=0;
   
}
myPixiObj.myGirl.prototype = Object.create(myPixiElement.container.prototype);
myPixiObj.myGirl.prototype= $.extend(myPixiObj.myGirl.prototype,{
    takePrefix:function(){
        return this.conf.prefix+"_"+this.conf.girl_id;
    },
    takeGirlId:function(){
        return this.conf.girl_id;
    },
    addToLoader:function(){
        var girl_name=$.takeGirlImage(this.conf.girl_id);
        var prefix=this.takePrefix();
        var res={};
        if(this.conf.is_own){
            res[prefix+"_girl"]=_IMG_SERV+"/gfx/girlsuit/"+girl_name+"/girl.png";
        }
        else{
            res[prefix+"_girl"]=_IMG_SERV+"/gfx/girlsuit/"+girl_name+"/girl_un.png";
        }
        res[prefix+"_eye1"]=_IMG_SERV+"/gfx/girlsuit/"+girl_name+"/eye1.png";
        res[prefix+"_eye2"]=_IMG_SERV+"/gfx/girlsuit/"+girl_name+"/eye2.png";
        
        var i,suit_id;
        for(i in this.conf.suitObj){
            suit_id=this.conf.suitObj[i];
            res[prefix+"_suit"+suit_id]=_IMG_SERV+"/gfx/girlsuit/"+girl_name+"/"+suit_id+".png";
        }
        return res;
        
        
    },
    init:function(){
        var prefix=this.takePrefix();
        this.addChild(new myPixiElement.img({
            img:prefix+"_girl",
            anchor:this.conf.anchor
        }));
        this.eyeArr.push(new myPixiElement.img({
            img:prefix+"_eye1",
            anchor:this.conf.anchor
        }));
        this.eyeArr.push(new myPixiElement.img({
            img:prefix+"_eye2",
            anchor:this.conf.anchor
        }));
        
        this.eyeArr[0].alpha=0;
        this.eyeArr[1].alpha=0;
        
        this.addChild(this.eyeArr[0]);
        this.addChild(this.eyeArr[1]);
        
        var i,suit_id;
        for(i in this.conf.suitObj){
            suit_id=this.conf.suitObj[i];
            this.addChild(new myPixiElement.img({
                img:prefix+"_suit"+suit_id,
                anchor:this.conf.anchor
            }));
        }
    },
    
    myUpdateEye:function(delta){
        if(!this.conf.is_own){
            return false;
        }
        var eye=this.storage.eye;
        eye.step+=delta*eye.deltaMultiply*eye.dir;
        var step=Math.round(eye.step);
        if(eye.step_last==step){
            return 1;//optimalization
        }
        var img_max=2;
        
        
        if(step<0){
            eye.dir=1;
        }
        var img=step;
        if(img<0){
            img=0;
        }
        if(img>img_max*2-1){
            img=0;
        }
        else if(img>img_max){
            img=img_max-Math.abs(img-img_max);
        }
        if(step>=eye.step_max){
            eye.dir=-1;
            eye.step_max=mt_rand(this.conf.eye.scene_range[0],this.conf.eye.scene_range[1]);
            eye.step=eye.step_max;
            eye.step_last=eye.step_max;
        }

        if(eye.img_last!=img){
           if(img==0){
               this.eyeArr[0].alpha=0;
                this.eyeArr[1].alpha=0;
           }
           else if(img==1){
                this.eyeArr[0].alpha=1;
                this.eyeArr[1].alpha=0;
           }
           else if(img==2){
                this.eyeArr[0].alpha=0;
                this.eyeArr[1].alpha=1;
           }
           this.img_last=img;
        }
    },
    myUpdate:function(delta){
        myPixiElement.custom.myUpdate.call(this,delta);
        this.myUpdateEye(delta);
    },
    myRemove:function(){
    }
    
});




myPixiObj.myEye=function(conf){
    PIXI.Container.call(this);
    
    
    conf=$.extend({
        img:"",
        pos:[0,0],
        gap:2,
        img_max:2,
        interval:100,
        scene_range:[10,40]
    },conf);
    this.conf=conf;
    
    
    this.texture = PIXI.utils.TextureCache[conf.img];
    var cardImg=new PIXI.Sprite(this.texture);
    this.addChild(cardImg);
    
    
    this.img=cardImg;
    this.clip_size=[];
    this.clip_size[0]=(cardImg.width-conf.gap*(conf.img_max-1))/conf.img_max;
    this.clip_size[1]=cardImg.height;
    
    this.texture.frame=new PIXI.Rectangle(0, 0, this.clip_size[0], this.clip_size[1]);

    this.x=conf.pos[0];
    this.y=conf.pos[1];

    this.img_last=-1;
    this.alpha=0;
    this.dir=1;
    this.deltaMultiply=1000/60/this.conf.interval;
    this.step_last=-1000;
    
    this.step_max=mt_rand(conf.scene_range[0],conf.scene_range[1])
    this.step=mt_rand(0,this.step_max-1);
};
myPixiObj.myEye.prototype = Object.create(PIXI.Container.prototype);
myPixiObj.myEye.prototype= $.extend(myPixiObj.myEye.prototype,{
    update:function(delta){
        
        this.step+=delta*this.deltaMultiply*this.dir;
        var step=Math.round(this.step);
        if(this.step_last==step){
            return 1;//optimalization
        }
        var img_max=this.conf.img_max;
        
        if(this.conf.img=="girl_eye1"){
//                $.qLog(delta+" ");
        }
        
        
        if(step<0){
            this.dir=1;
        }
        var img=step;
        if(img<0){
            img=0;
        }
        if(img>img_max*2-1){
            img=0;
        }
        else if(img>img_max){
            img=img_max-Math.abs(img-img_max);
        }
        if(step>=this.step_max){
            this.dir=-1;
            this.step_max=mt_rand(this.conf.scene_range[0],this.conf.scene_range[1]);
            this.step=this.step_max;
            this.step_last=this.step_max;
        }

        if(this.img_last!=img){
            if(this.conf.img=="girl_eye1"){
//                $.qLog(img+" ");
            }
            if(img==0){
                this.alpha=0;
            } 
            else{
                this.alpha=1;
                var frame_left=(img-1)*(this.clip_size[0]+this.conf.gap);
                this.texture.frame=new PIXI.Rectangle(frame_left, 0, this.clip_size[0], this.clip_size[1]);
            }
           
           this.img_last=img;
        }
        
        
        

        return 1;

    },
    remove:function(){
        this.destroy();
    }
});






myPixiButton=function(conf,resources){
    PIXI.Container.call(this);
    this.conf=$.extend({
       texture_name:"",
       state_arr:["normal","active","hover"],
       anchor:[0.5,0.5]
    },conf);
    
//    resources
    
    this.texture =new PIXI.Texture(resources[conf.texture_name].texture);


            
            
    
    this.conf.width=this.texture.baseTexture.width;
    this.conf.height=this.texture.baseTexture.height/3;
    
    this.frameRectangle = new PIXI.Rectangle(0, 0, this.conf.width, this.conf.height);
    this.texture.frame= this.frameRectangle;
    
    
    this.state="normal";
    this.background=new PIXI.Sprite(this.texture);
    this.background.anchor.set(this.conf.anchor[0],this.conf.anchor[1]);
    this.addChild(this.background);
};
myPixiButton.prototype = Object.create(PIXI.Container.prototype);
myPixiButton.prototype= $.extend(myPixiButton.prototype,{
    setState:function(state){
        if(!in_array(state,this.conf.state_arr) || this.state==state){
            return false;
        }
        var i,bum,val=0;
        for(i in this.conf.state_arr){
            bum=this.conf.state_arr[i];
            if(bum==state){
                val=intval(i);
            }
        }
        this.state=state;
        this.frameRectangle = new PIXI.Rectangle(0, this.conf.height*val, this.conf.width, this.conf.height);
        this.texture.frame= this.frameRectangle;
        return true;
    },
    takeState:function(){
        return this.state;
    },
    update:function(delta){
        
    },
    remove:function(){
        this.myObj.myRemove();
        this.destroy();
    }
});






myPixiBar=function(conf,resources){
    PIXI.Container.call(this);
    this.conf=$.extend({
       texture_name:"",
       val:0,
       val_max:0,
       pos:[0,0],
       anchor:[0,0],
       vertical:false,
       textureCount:1,
       onEnd:function(){}
    },conf);

//    resources
    this.textureName;
    if(typeof conf.texture_name === "string") {
      this.textureName = conf.texture_name;
    } else {
      this.textureName = conf.texture_name[0];
      this.conf.textureCount = conf.texture_name.length;
    }
    this.texture = new PIXI.Texture(resources[this.textureName].texture);


   this.x=this.conf.pos[0];
   this.y=this.conf.pos[1];


    this.conf.width=this.texture.baseTexture.width;
    this.conf.height=this.texture.baseTexture.height;
    this.pivot.set(
        Math.round(this.conf.width*this.conf.anchor[0]),
        Math.round(this.conf.height*this.conf.anchor[1])
    );
    this.width=this.conf.width;
    this.height=this.conf.height;
    var width=this.conf.val/this.conf.val_max*this.conf.width;

    this.frameRectangle = new PIXI.Rectangle(0, 0, width, this.conf.height);
    this.texture.frame= this.frameRectangle;


    this.background=new PIXI.Sprite(this.texture);
    this.background.anchor.set(0,0);
    this.addChild(this.background);
    
    this.storage={blocked:0};
    
    this.resources = resources;
};
myPixiBar.prototype = Object.create(PIXI.Container.prototype);
myPixiBar.prototype= $.extend(myPixiBar.prototype,{
    updateVal:function(val){
        if(this.conf.val_max==0 || this.storage.blocked || this.conf.val==val){
            return false;
        }
        this.conf.val=val;
        var perc=this.conf.val/this.conf.val_max,width=this.conf.width,height=this.conf.height,recFix=0;
        if(!this.conf.vertical) {
          width = perc*this.conf.width;
          width=Math.min(width,this.conf.width);
        } else {
          height = perc*this.conf.height;
          height=Math.min(height,this.conf.height);
          height=Math.max(height,0);
          recFix=this.conf.height-height;
          this.y=recFix+this.conf.pos[1];
        }
//        $.qLog(Math.round(width)+"_"+this.conf.width+"_"+val+"_"+this.conf.val_max+" ");
        if(this.conf.textureCount>1 && perc<0.5) {
          var texture = this.conf.textureCount-Math.ceil(perc*10/this.conf.textureCount);
          texture = Math.min(this.conf.textureCount,texture);
          texture = Math.max(1,texture);
          this.updateTexture(texture);
        }
        this.frameRectangle = new PIXI.Rectangle(0, recFix, width, height);
        this.texture.frame= this.frameRectangle;
        if(perc>=100){
          this.conf.val = 0;
          this.conf.onEnd.call(this);
        }
        return true;
    },
    setBar:function(val,val_max){
        this.storage.blocked=1;
        this.conf.val_max=val_max;
        this.storage.blocked=0;
        
        if(typeof this.conf.texture_name !== "string") {
            this.updateTexture(0);
          }
        
        this.updateVal(val);
        
        
    },
    getVal:function (val) {
      if(this.conf.val == 0){
        this.conf.val = this.conf.val_max;
      }
      var newVal = this.conf.val-val;
      this.updateVal(newVal);
    },
    setValMax:function(val_max){
        this.conf.val_max=val_max;
    },
    updateTexture:function (name) {
      if(typeof this.conf.texture_name[name] == "undefined") {
        return 0;
      }
      var newTexture = this.conf.texture_name[name];
      if(this.textureName == this.conf.texture_name[name]) {
        return false;
      }
      this.textureName = newTexture;
      this.texture = new PIXI.Texture(this.resources[newTexture].texture);
      this.removeChild(this.background);
      this.background=new PIXI.Sprite(this.texture);
      this.background.anchor.set(0,0);
      this.addChild(this.background);
    },
    remove:function(){
        this.myObj.myRemove();
        this.destroy();
    }
});



myPixiClock = function (conf,resources) {
  PIXI.Container.call(this);
  this.conf=$.extend({
     texture_name:{
       hand:"",
       face:""
     },
     val:0,
     clock_color:"ff0000",
     val_max:0,
     pos:[0,0],
     anchor:[0,0],
     fillRadius:0,
     onEnd:function(){}
  },conf);

  // this.textureHand = new PIXI.Texture(resources[conf.texture_name.hand].texture);
  // this.textureFace = new PIXI.Texture(resources[conf.texture_name.face].texture);
  this.textureHand = PIXI.utils.TextureCache[conf.texture_name.hand];
  this.textureFace = PIXI.utils.TextureCache[conf.texture_name.face];

  this.conf.width = this.textureFace.baseTexture.width;
  this.conf.height = this.textureFace.baseTexture.height;

  this.x = conf.pos[0];
  this.y = conf.pos[1];


  this.background=new PIXI.Sprite(this.textureFace);
  this.background.anchor.set(0,0);

  this.hand = new PIXI.Sprite(this.textureHand);
  this.hand.anchor.set(0.5,1);

  this.handContainer = new PIXI.Container();
  this.handContainer.x = this.conf.width/2;
  this.handContainer.y = this.conf.height/2;

  if(this.conf.fillRadius==0){
    this.conf.fillRadius=this.handContainer.y;
  }
  
  this.storage={blocked:0};

  // this.fillCircle.closePath();
// this.fillCircle.fill();

  this.addChild(this.background);
  this.addChild(this.handContainer);
}
myPixiClock.prototype = Object.create(PIXI.Container.prototype);
myPixiClock.prototype = $.extend(myPixiClock.prototype,{
  getVal:function (val) {
    if(this.conf.val_max==0){
      return false
    }
    if(this.conf.val == 0){
      this.conf.val = this.conf.val_max;
    }
    var newVal = this.conf.val-val;
    this.updateVal(newVal);
  },
  setValMax:function (val) {
    this.conf.val_max = val;
  },
  clearValues:function () {
    this.conf.val = 0;
    this.conf.val_max = 0;

  },
  setClock:function(val,val_max){
      this.storage.blocked=1;
      this.conf.val_max=val_max;
      this.storage.blocked=0;
      this.updateVal(val);
  },
  takeVal:function(){
      return this.conf.val;
  },
  updateVal:function (val) {
        if(this.conf.val_max==0 || this.storage.blocked || this.conf.val==val){
            return false;
        }
        this.conf.val = val;
        // this.hand.rotation += delta * 0.1;
        var perc = 0,deg = 0;

        perc = this.conf.val/this.conf.val_max;
        if(perc>0){
          this.handContainer.removeChildren();
          deg = 360*perc;
          this.hand.rotation = deg/180*Math.PI;
          var start = 0.5*Math.PI;
          this.fillCircle = new PIXI.Graphics();
          this.fillCircle.beginFill("0x"+this.conf.clock_color);
          this.fillCircle.moveTo(0,0);
          this.fillCircle.lineTo(0,0);
          this.fillCircle.endFill();
          this.fillCircle.arc(0,0,this.conf.fillRadius,-start,this.hand.rotation-start);
          this.handContainer.addChild(this.fillCircle);
          this.handContainer.addChild(this.hand);
        }
        if(perc>=100){
          this.conf.val = 0;
          this.conf.onEnd.call(this);
        }
  }
});
